<template>
  <div id="video-container">
    <div class="flex-sp">
      <div class="add-title">
        {{ videoTitle }}
      </div>
      <div>
        <butn
          btntype="primary"
          iconName="el-icon-arrow-left"
          title="返回"
          @click="$router.back()"
        ></butn>
      </div>
    </div>
    <div id="dplayer"></div>
  </div>
</template>

<script>
import DPlayer from "dplayer";
import { shortVideoInfo } from "@/api/shortVideo";
import butn from "@/components/button/index";

export default {
  components: { butn },
  data() {
    return {
      videoTitle: "",
      videoInfo: {
        videoLink: "",
        coverUrl: ""
      }
    };
  },
  created() {
    var _this = this;
    _this.$nextTick(() => {
      shortVideoInfo(_this.$route.query.id).then(res => {
        if (!res || res.code != 0) return;
        const { data } = res;
        _this.initPlayer(data);
      });
    });
  },
  methods: {
    initPlayer(item) {
      this.videoTitle = item.videoName;
      this.videoInfo = item;
      const that = this;
      new DPlayer({
        container: document.getElementById("dplayer"),
        autoplay: false,
        theme: "#6196fc",
        loop: false,
        lang: "zh-cn",
        hotkey: true,
        preload: "auto",
        volume: 0.7,
        mutex: true,
        video: {
          url: that.videoInfo.videoLink,
          type: "auto"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#video-container {
  width: calc(100% - 550px);
  height: 100%;
  padding: 0 25%;
  overflow: auto;
  #dplayer {
    width: 100%;
    margin-top: 5%;
  }
}
.flex-sp {
  display: flex;
  justify-content: space-between;
  width: 750px;
}
</style>
